import CustomSelectWithInfiniteScroll from 'common/components/CustomSelectWithInfiniteScroll';
import CalendarType from 'common/enums/calendarTypes';
import { useSearchParams } from 'react-router-dom';
import { fetchCalendarsAction } from 'redux/slices/iCalendarV4';

const SelectUsers = (props) => {
    const { groupParamId, ...rest } = props;
    const [params] = useSearchParams();
    const groupId = groupParamId || params.get('group') || 'all';

    return (
        <CustomSelectWithInfiniteScroll
            {...rest}
            type="agent"
            idProperty="canonicalId"
            queryParams={{
                type: CalendarType.AGENT,
                ...(groupId !== 'all' ? { userGroupId: groupId } : {}),
            }}
            selectAll={true}
            fetchAction={fetchCalendarsAction}
            queryOptions={{ useState: false }}
            label={(item) => <>{item.name}</>}
            i18nKeys={{
                searchPlaceholder: 'iCalendar.filter.searchAgents',
                allItems: 'iCalendar.filter.allAgents',
            }}
        />
    );
};

export default SelectUsers;
